import {NgModule} from "@angular/core";
import {DashboardComponent} from "./dashboard.component";
import {CommonModule} from "@angular/common";
import {MatCardModule} from "@angular/material/card";
import {MatListModule} from "@angular/material/list";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSelectModule} from "@angular/material/select";
import {OrderByModule} from "@app/pipes/order-by/order-by.module";
import {FormsModule} from "@angular/forms";
import {MatTabsModule} from "@angular/material/tabs";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";
import {MatDialogModule} from "@angular/material/dialog";
import {UsernameToNameModule} from "@app/pipes/username-to-name/username-to-name.module";

@NgModule({
    declarations:[DashboardComponent],
    imports: [CommonModule,
        MatCardModule,
        MatListModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatSelectModule,
        OrderByModule,
        FormsModule,
        MatTabsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        LogPipeModule,
        MatDialogModule,
        UsernameToNameModule]
})
export class DashboardModule{}
